/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button[_ngcontent-%COMP%], dx-text-box[_ngcontent-%COMP%]{width:100%}mat-form-field[_ngcontent-%COMP%]{display:block;width:100%;margin-bottom:10px}mat-form-field[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{cursor:pointer}.email-sent[_ngcontent-%COMP%]{color:gray;font-size:11px;margin:-20px 0 20px;font-style:italic}"];
export { styles as styles };
